import { useState } from "react";

import AddIcon from "@mui/icons-material/Add";
import EditIcon from "@mui/icons-material/Edit";
import { Box, Divider, IconButton, Stack, Tooltip, Typography } from "@mui/material";

import { Trans, useTranslation } from "@/translations";

import { JournalSupportEntry } from "./JournalSupportEntry";
import { useActiveJournalSupports } from "./hooks/useActiveJournalSupports";
import { JournalSupportCreationDialog } from "./journal-support-creation/JournalSupportCreationDialog";
import { JournalSupportEditDialog } from "./journal-support-edit/JournalSupportEditDialog";

export function JournalSupportSection() {
  const { t } = useTranslation();
  const { active, currentUserActive } = useActiveJournalSupports();
  const [dialogOpen, setDialogOpen] = useState(false);

  const isCurrentUserActive = currentUserActive !== null;

  const countKey =
    active.length === 0 ? "calendar.journalSupport.activeCountZero" : "calendar.journalSupport.activeCount";

  return (
    <>
      <Divider />
      <Box sx={{ bgcolor: "fsw.blue-5", px: 2, py: 1.5 }}>
        <Stack direction="row" alignItems="center" justifyContent="space-between" gap={1}>
          <Stack direction="row" alignItems="center" gap={1} flex={1} minWidth={0}>
            <Box
              component="span"
              sx={{
                display: "inline-block",
                width: 10,
                height: 10,
                borderRadius: "50%",
                bgcolor: active.length > 0 ? "success.main" : "text.disabled",
                flexShrink: 0,
              }}
            />
            <Typography variant="body2">
              <Trans i18nKey={countKey} count={active.length} components={{ bold: <strong /> }} />
            </Typography>
          </Stack>
          <Tooltip
            title={
              isCurrentUserActive ? t("calendar.journalSupport.editTitle") : t("calendar.journalSupport.registerTitle")
            }
          >
            <IconButton
              size="small"
              onClick={() => setDialogOpen(true)}
              aria-label={
                isCurrentUserActive
                  ? t("calendar.journalSupport.editTitle")
                  : t("calendar.journalSupport.registerTitle")
              }
            >
              {isCurrentUserActive ? <EditIcon fontSize="small" /> : <AddIcon fontSize="small" />}
            </IconButton>
          </Tooltip>
        </Stack>

        {active.length > 0 && (
          <Box
            sx={{
              display: "grid",
              gridTemplateColumns: "repeat(3, 1fr)",
              rowGap: "4px",
              columnGap: 0.5,
              mt: 1,
              maxHeight: "48px",
              overflowY: "auto",
            }}
          >
            {active.map((entry) => (
              <JournalSupportEntry key={entry.id} entry={entry} />
            ))}
          </Box>
        )}
      </Box>

      {dialogOpen && currentUserActive && (
        <JournalSupportEditDialog entry={currentUserActive} onClose={() => setDialogOpen(false)} />
      )}
      {dialogOpen && !currentUserActive && <JournalSupportCreationDialog onClose={() => setDialogOpen(false)} />}
    </>
  );
}
